<template>
  <div class="user-info-container">
    <div class="profile-header">
      <div class="header-content">
        <div class="title-section">
          <h2 class="profile-title">{{ pageName }}</h2>
          <v-btn
            v-if="showUserData"
            @click="toggleUserData"
            class="btn-secondary"
            outlined
            small>
            <v-icon style="font-size: 18px !important;">mdi-pencil</v-icon>
            Edit
          </v-btn>
        </div>
      </div>
    </div>    
    <div class="profile-content">
      <UserData v-bind:userInfo="userInfo" v-if="showUserData" />
      <UserInfoForm v-bind:userInfo="userInfo" v-if="showUserInfoForm" @cancel="toggleUserData" />
    </div>
  </div>
</template>
<script>

import UserInfoForm from '../../components/Forms/UserInfoForm';
import UserData from '../../components/DataDisplay/UserData';
import DataService from '../../../_services/DataService';

export default {
  props: [],
  name: 'UserInfo',
  components: { UserInfoForm, UserData },
  data() {
    return {
      showUserData: true,
      showUserInfoForm: false,
      pageName: 'Patient Profile',
      pageIcon: 'mdi-account-circle-outline',
      editIcon: 'mdi-pencil-outline',
      userInfo: '',
    };
  },
  methods: {
    async toggleUserData() {
      this.showUserData = !this.showUserData;
      this.showUserInfoForm = !this.showUserInfoForm;

      await this.getData();
    },
    async getData(){
      const response = await DataService.getPatientInfo();

      this.userInfo = response.data;
    },
  },
  async created() {
    await this.getData();
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import '@/scss/variables.scss';

.user-info-container {
  padding: 24px;

  .profile-header {
    margin-bottom: 8px;
    border-bottom: 1px solid #e2e8f0;
    padding-bottom: 16px;

    .header-content {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .title-section {
        display: flex;
        align-items: center;
        gap: 16px;

        .profile-title {
          font-size: 20px;
          font-weight: 600;
          color: #2d3748;
          margin: 0;
          font-family: 'Inter', sans-serif;
        }
      }
    }
  }

  .profile-content {
    background-color: #ffffff;
    border-radius: 12px;
    box-shadow: $shadow-md;
    padding: 24px;
    position: relative;

    @media (max-width: $breakpoint-mobile) {
      padding: 0;
    }
  }
}
</style>
